export class MappingTipiEntitaPratica {
  public static PRATICA_LAVORO = '5896d998-53e7-11ea-a08d-005056a8dd09'; // number = 1;
  public static PRATICA_CIVILE = '58a00511-53e7-11ea-a08d-005056a8dd09'; // number = 2;
  public static PRATICA_TRIBUTARIO = '58a65e7e-53e7-11ea-a08d-005056a8dd09'; // number = 3;
  public static PRATICA_AMMINISTRATIVA = '58ac8ea5-53e7-11ea-a08d-005056a8dd09'; // number = 4;
  public static PRATICA_AUTORITA_INDIPENDENTE = '58b1c7d9-53e7-11ea-a08d-005056a8dd09'; // number = 5;
  public static PRATICA_PENALE = '58b65f6c-53e7-11ea-a08d-005056a8dd09'; // number = 6;
  public static PRATICA_PARERISTICA = '58bc2192-53e7-11ea-a08d-005056a8dd09'; // number = 7;
}
